import React from 'react'
import { Container, Label, LoaderComponent } from './styles'

export interface ButtonProps {
  loading?: boolean
  disabled?: boolean
  label: string
  color: 'default' | 'error' | 'secondary' | 'primary' | 'success'
  type?: 'button' | 'submit' | 'reset' | undefined
  variantType: 'block' | 'outline' | 'label' | 'small'
  fullWidth?: boolean
  onClick?: React.MouseEventHandler<HTMLButtonElement>
}

const Button: React.FunctionComponent<ButtonProps> = ({
  label,
  variantType,
  color = 'default',
  fullWidth = false,
  type = 'button',
  onClick,
  disabled,
  loading,
}) => (
  <Container
    $fullWidth={fullWidth}
    disabled={disabled}
    $loading={loading}
    $color={color}
    $variantType={variantType}
    type={type}
    onClick={onClick}
  >
    {loading ? <LoaderComponent color='white' /> : <Label> {label} </Label>}
  </Container>
)

export default Button
